import CarouselMediaSectionTheme from './CarouselMediaSection';

export { default as CarouselMediaSectionTheme } from './CarouselMediaSection.style';
export default CarouselMediaSectionTheme;
